// extracted by mini-css-extract-plugin
module.exports = {"likes":"Likes_likes__1enf0"};